import { useTranslation } from 'react-i18next'

import { Product } from '@shared/generated'

import styles from './styles.module.scss'

export interface ProductPropertiesProps {
  product: Product;
}

export default function ProductProperties (props: ProductPropertiesProps) {
  const { t } = useTranslation('product')
  const { product } = props
  const properties = product.productProperties

  return (
    <div className={styles.root}>
      {properties?.calories != null && (
        <div className={styles.root__item}>
          <span className={styles.root__value}>{properties.calories}</span>
          <span className={styles.root__label}>{t('nutrition.calories')}</span>
        </div>
      )}
      {properties?.proteins != null && (
        <div className={styles.root__item}>
          <span className={styles.root__value}>{properties.proteins}</span>
          <span className={styles.root__label}>{t('nutrition.proteins')}</span>
        </div>
      )}
      {properties?.fats != null && (
        <div className={styles.root__item}>
          <span className={styles.root__value}>{properties.fats}</span>
          <span className={styles.root__label}>{t('nutrition.fats')}</span>
        </div>
      )}
      {properties?.carbohydrate != null && (
        <div className={styles.root__item}>
          <span className={styles.root__value}>{properties.carbohydrate}</span>
          <span className={styles.root__label}>{t('nutrition.carbohydrates')}</span>
        </div>
      )}
    </div>
  )
}
